import axios from 'shared/utils/axios'
import queryString from 'qs'

import { PayloadAction } from '@reduxjs/toolkit'
import { call, takeLatest, put } from 'redux-saga/effects'
import { getUserRoles, getUserInbox, setRoles, setInbox } from './reducer'
import { UserRoleTypeWithStatus } from 'pages/UserRole/model/role'
import { MessageRowItem } from 'pages/Communications/model/message'
import { PaginatedList } from 'shared/types'

function* GetUserRoles() {
	try {
		const roleQueryString = queryString.stringify({
			sidebar: true,
			kiosk: true,
			status: 'Active',
			fields: ['id', 'name', 'permission_ids'],
			sort: [{ column: 'level', direction: 'desc' }],
		})

		const response: UserRoleTypeWithStatus[] = yield call(axios.request, {
			url: `/user/role?${roleQueryString}`,
		})

		yield put(setRoles(response))
	} catch (err) {
		console.error(err)
	}
}

function* GetUserInbox() {
	try {
		const inboxQueryString = queryString.stringify({
			is_read: false,
			status: 'Active',
			fields: ['id', 'subject'],
			sort: [{ column: 'created_date', direction: 'desc' }],
			page: 0,
			size: 1
		})

		const response: PaginatedList<MessageRowItem> = yield call(axios.request, {
			url: `/message/inbox?${inboxQueryString}`,
		})

		yield put(setInbox(response.count))
	} catch (err) {
		console.error(err)
	}
}

export default function* rootSaga() {
  yield takeLatest(getUserRoles.type, GetUserRoles)
  yield takeLatest(getUserInbox.type, GetUserInbox)
}
